module.exports = __webpack_public_path__ + "img/zoom-out.3f8661c4.svg";